import React from 'react';
import CustomizedSnackbars from '../../Alert';
export default function Footer({ footer, website, facebook, twitter }) {
  const [alert, setAlert] = React.useState({ counter: 0, type: '', msg: '' });

  const showAlert = (type, msg) => {
    setAlert((prev) => ({
      counter: prev.counter + 1,
      type,
      msg,
    }));
  };

  const openLink = (url) => {
    const regExURL = /^(ftp|http|https):\/\/[a-zA-Z0-9_.%\-/]+$/;

    if (url && regExURL.test(url)) {
      window.open(url, '_blank');
    } else {
      showAlert('error', 'Invalid or broken URL');
    }
  };

  return (
    <>
      {alert.counter > 0 && (
        <CustomizedSnackbars status={alert.counter} msg={alert.msg} type={alert.type} />
      )}

      <footer className="global-footer">
        <div className="footer-container">
          {/* TOP SECTION */}
          {/* <div className="footer-top-grid">
           
            <div className="footer-alert-card">
              <div className="alert-header">
                <span
                  className="material-symbols-outlined text-warning"
                  style={{ color: '#f59e0b' }}
                >
                  warning
                </span>
                <span className="alert-title">SECURITY WARNING</span>
              </div>
              <p className="alert-body">
                If any suspicious person contacts you in the name of ITMines, do not trust and
                report immediately.
              </p>
            </div>

         
            <div className="footer-details-sec">
              <h4 className="details-title">INSTITUTIONAL DETAILS</h4>

              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">PRINCIPAL OFFICER</span>
                  <span className="detail-value">Mr. Jonathan Doe</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">TYPE OF REGISTRATION</span>
                  <span className="detail-value">Non-Individual RIA</span>
                </div>

                <div className="detail-item span-full mt-2">
                  <span className="detail-label">SEBI REGISTRATION NO.</span>
                  <span className="detail-value">
                    INA000004070 <span className="validity">(Valid till 2026)</span>
                  </span>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="footer-divider-lg"></div> */}

          {/* BOTTOM SECTION */}
          <div className="footer-bottom-row">
            {/* Left */}
            <p>{footer || '© 2026 ITMines. All rights reserved.'}</p>

            {/* Center */}
            <p className="powered-text">
              POWERED BY{' '}
              <a
                href="https://www.itmines.co.in"
                style={{ textDecoration: 'none' }}
                target="_blank"
                aria-label="itmines website link"
              >
                ITMINES
              </a>
            </p>

            {/* Right: Social Links */}
            <div className="footer-socials-row">
              {/* Twitter */}
              {twitter && (
                <button
                  className="social-square"
                  type="button"
                  onClick={() => openLink(twitter)}
                  aria-label="Twitter"
                >
                  X
                </button>
              )}

              {/* Website */}
              {website && (
                <button
                  className="social-square"
                  type="button"
                  onClick={() => openLink(website)}
                  aria-label="Website link"
                >
                  <span className="material-symbols-outlined">language</span>
                </button>
              )}

              {/* Facebook */}
              {facebook && (
                <button
                  className="social-square"
                  type="button"
                  onClick={() => openLink(facebook)}
                  aria-label="Facebook"
                >
                  f
                </button>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
